import BadExample from "../../../../content/blog/0007-yall-wanna-see-something-wild/BadExample";
import UseTheForce from "../../../../content/blog/0007-yall-wanna-see-something-wild/UseTheForce";
import React from 'react';
export default {
  BadExample,
  UseTheForce,
  React
};